/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { DiagnosticFormattedQuestion, DiagnosticQuestionOptionWithSelection, LanguageValue, Organization } from '../../models';

@Component({
  selector: 'ptl-diagnostics-view-list-question-type',
  templateUrl: './list-question-type.component.html',
  styleUrls: ['./list-question-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsViewListQuestionTypeComponent implements OnInit {
  /** Receives the question to answer */
  @Input() question: DiagnosticFormattedQuestion;
  @Input() answeredQuestions;
  @Input() disabled: boolean;
  @Input() isFeedbackFor: boolean;
  @Input() currentLanguage: string;
  @Input() organization: Organization;

  formattedQuestions: DiagnosticFormattedQuestion[] = [];

  /** Emits the answer when selected. */
  @Output() selectedAnswer = new EventEmitter<{
    uid: string;
    answer: DiagnosticQuestionOptionWithSelection[];
  }>();

  instruction: string;
  options: (DiagnosticQuestionOptionWithSelection & { title: string })[] = [];

  selectedRadioItem: DiagnosticQuestionOptionWithSelection;
  selectedMultiple: (DiagnosticQuestionOptionWithSelection & { title: string })[] = [];
  selectedOptions: DiagnosticQuestionOptionWithSelection[] = [];

  private selectedItemsCount = 0;

  ngOnInit() {
    if (this.question) {
      this.instruction =
        LanguageCodeHelper.getDataByUserLanguageCode(this.question.instructions, this.organization, this.currentLanguage).value ?? '';
      this.options = [...this.question.options].map((option) => {
        const instruction = LanguageCodeHelper.getDataByUserLanguageCode(option.values, this.organization, this.currentLanguage);
        return {
          ...option,
          selected: false,
          title: instruction.value,
        };
      });

      const selectedQuestion = this.answeredQuestions[this.question.uid];
      if (selectedQuestion) {
        this.selectedOptions = [];
        for (const item of selectedQuestion) {
          this.options.map((op) => {
            if (op.uid === item.optionUid) {
              this.selectedOptions.push(op);
            }
          });
        }
        this.selectAnswer();
      }
    }
  }

  getTranslatedValue(values: LanguageValue[]) {
    return LanguageCodeHelper.getDataByUserLanguageCode(values, this.organization, this.currentLanguage).value;
  }

  isCheckboxDisabled(option: DiagnosticQuestionOptionWithSelection): boolean {
    const limit = this.question.selectionLimit;
    const selectedCount = this.selectedOptions.length;
    return limit && selectedCount >= limit && !option.selected;
  }

  onCheckboxChange(option: DiagnosticQuestionOptionWithSelection): void {
    this.selectedOptions = this.options.filter((op) => op.selected);
    this.selectAnswer();
  }

  onRadioChange(): void {
    this.selectedOptions = [this.selectedRadioItem];
    this.selectAnswer();
  }

  onSelectChange(): void {
    this.selectedOptions = this.selectedMultiple;
    this.selectAnswer();
  }

  selectAnswer(): void {
    this.selectedOptions.map((op) => (op.selected = true));
    this.selectedItemsCount = this.selectedOptions.length;
    this.selectedAnswer.emit({ uid: this.question.uid, answer: this.selectedOptions });
  }
}
